module.exports = __webpack_public_path__ + "assets/images/Saiba-mais_amarelinha_e6d9ac6fde39bd03a75cdacf2ed52768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-four/Saiba-mais_amarelinha.png
// module id = 213
// module chunks = 0